//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface AngemeldeteFilter {
    probenNr?: number | null;
    bezeichnung?: string | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    lieferant?: string | null;
    mhd?: string | null;
    filterTyp?: FilterTyp;
    eingangsdatumFilterVerfuegbar?: boolean;
    eingangsdatumVon?: Date | null;
    eingangsdatumBis?: Date | null;
    datumProbenziehungVon?: Date | null;
    datumProbenziehungBis?: Date | null;
    ausgangsdatumFilterVerfuegbar?: boolean;
    ausgangsdatumVon?: Date | null;
    ausgangsdatumBis?: Date | null;
    erlaubteFilterTypen?: FilterTyp[];
    parameterbezeichnung?: string | null;

    [key: string]: any;
}

export interface Anmelden {
    benutzername?: string;
    kennwort?: string;

    [key: string]: any;
}

export enum Ansicht {
    ErgebnisTabellen = "ErgebnisTabellen",
    ErfassenTabellen = "ErfassenTabellen",
    ExcelExport = "ExcelExport",
    ExcelImport = "ExcelImport",
    GutachtenVersionenErgebnistabellen = "GutachtenVersionenErgebnistabellen",
    Begehungsberichte = "Begehungsberichte",
    GutachtenRohstoffspezifikationen = "GutachtenRohstoffspezifikationen",
    GutachtenErfassenTabellen = "GutachtenErfassenTabellen",
}

export interface Badge {
    text: string;
    hervorgehoben?: boolean;
    tooltip?: { [key: string]: string; };

    [key: string]: any;
}

export interface Badges {
    proben?: Badge | null;
    mustervorlagen?: Badge | null;
    ergebnisse?: { [key: string]: Badge; };
    gutachten?: { [key: string]: Badge; };
    rohstoffspezifikationen?: Badge | null;
    sindBegehungsberichteVorhanden?: boolean;
    sindGutachtenVorhanden?: boolean;
    sindRohstoffspezifikationenVorhanden?: boolean;
    sindZertifikateVorhanden?: boolean;

    [key: string]: any;
}

export interface BavTeam {
    eMail?: string | null;
    telefonnummer?: Telefonnummer | null;

    [key: string]: any;
}

export interface Belastungstest {
    beurteilungLabel?: { [key: string]: string; };
    beurteilungText?: string | null;
    beurteilung?: Beurteilung | null;
    pruefplanLabel?: { [key: string]: string; };
    pruefplan?: string | null;
    belastungstestPruefberichtLabel?: string | null;
    belastungstestTestdurchfuehrung?: string | null;
    parameterTabelle: BelastungstestTabelle;
    kriterienTabellen: KriterienTabelle[];
    tabellenunterschriftErgebnis?: string | null;
    hinweisLabel?: { [key: string]: string; };
    hinweis?: string | null;
    mibiBelastungstestUntersuchungsbeginn?: Date | null;
    abgebrochen?: boolean;
    abgebrochenAm?: Date | null;
    abgebrochenVon?: string | null;
    abbruchHinweis?: string | null;
    abbruchGrund?: string | null;
    abbruchGruende?: BelastungstestAbbruchGrundModel[];

    [key: string]: any;
}

export interface BelastungstestAbbrechenRequest {
    probenNr?: number | null;
    abbruchGrundID?: BelastungstestAbbruchGrund;
    hinweis?: string | null;

    [key: string]: any;
}

export enum BelastungstestAbbruchGrund {
    BisherigeErgebnisse = "BisherigeErgebnisse",
    InstabilitaetDerProbe = "InstabilitaetDerProbe",
    RezepturWirdNichtWeiterVerfolgt = "RezepturWirdNichtWeiterVerfolgt",
    AndererGrund = "AndererGrund",
}

export interface BelastungstestAbbruchGrundModel {
    id: BelastungstestAbbruchGrund;
    bezeichnung: string;
    uebersetzungen?: { [key: string]: string; };

    [key: string]: any;
}

export interface BelastungstestTabelle {
    zeilen?: Zeile[];

    [key: string]: any;
}

export enum Beurteilung {
    KeineBeurteilung = "KeineBeurteilung",
    Zufriedenstellend = "Zufriedenstellend",
    Akzeptabel = "Akzeptabel",
    NichtZufriedenstellend = "NichtZufriedenstellend",
}

export interface Checkliste {
    checklistenID?: number;
    durchgefuehrtAm?: Date;
    bemerkung?: string | null;
    erreichtePunktzahl?: number | null;
    erreichbarePunktzahl?: number | null;
    erreichtePunktzahlProzent?: number | null;
    checklistenBewertungsSystemID?: ChecklistenBewertungsSystem;
    pdf?: string | null;
    massnahmenplan?: string | null;
    bilder?: ChecklistenBild[];

    [key: string]: any;
}

export interface ChecklisteDetail {
    kundennummer: string;
    betrieb: string;
    plzOrtStrasse: string;
    nichtZutreffendBezeichnung: string;
    bereiche?: ChecklistenBereich[];
    navigation?: Navigation;
    checklistenID?: number;
    durchgefuehrtAm?: Date;
    bemerkung?: string | null;
    erreichtePunktzahl?: number | null;
    erreichbarePunktzahl?: number | null;
    erreichtePunktzahlProzent?: number | null;
    checklistenBewertungsSystemID?: ChecklistenBewertungsSystem;
    pdf?: string | null;
    massnahmenplan?: string | null;
    bilder?: ChecklistenBild[];

    [key: string]: any;
}

export interface ChecklistenBereich {
    checklistenBereichID?: number;
    bereichNr?: string | null;
    bezeichnung?: string | null;
    fragen?: ChecklistenFrage[];
    erreichtePunktzahl?: number | null;
    erreichbarePunktzahl?: number | null;
    erreichtePunktzahlProzent?: number | null;
    istNichtZutreffend?: boolean;

    [key: string]: any;
}

export enum ChecklistenBewertungsSystem {
    BAV = "BAV",
    KOKriterien = "KOKriterien",
}

export interface ChecklistenBild {
    checklistenFrageID?: number;
    documentGuid?: string;
    fragePositionsNr?: number;
    bereichPositionsNr?: number;
    filename: string;

    [key: string]: any;
}

export interface ChecklistenFrage {
    checklistenFrageID?: number;
    frageNr?: string | null;
    frage?: string | null;
    punktzahl?: number | null;
    bemerkung?: string | null;
    bilder?: ChecklistenBild[];

    [key: string]: any;
}

export interface Chemie {
    beurteilung?: Beurteilung | null;
    pruefplan?: string | null;
    parameter?: ChemieParameter[];
    bemerkung?: string | null;
    chemieReferenzmengeFussnote?: string | null;
    chemieErgebnisMitMessunsicherheit?: boolean;
    chemieErgebnisMitReferenzmenge?: boolean;
    chemieParameterGruppenUeberschriftenDrucken?: boolean;

    [key: string]: any;
}

export interface ChemieParameter {
    parameter?: string | null;
    ergebniswert?: string | null;
    ergebniswertReferenzmenge?: string | null;
    messunsicherheitHtml?: string | null;
    gruppe?: string | null;

    [key: string]: any;
}

export interface Color {
    r?: number;
    g?: number;
    b?: number;
    a?: number;
    isKnownColor?: boolean;
    isEmpty?: boolean;
    isNamedColor?: boolean;
    isSystemColor?: boolean;
    name?: string | null;

    [key: string]: any;
}

export interface Dashboard {
    apName?: string | null;
    bavTeam?: BavTeam | null;
    zentraleTelefonnummer?: Telefonnummer;
    news?: News[];

    [key: string]: any;
}

export interface Dokument {
    name: string;
    groesse: string;
    groesseBytes: number;

    [key: string]: any;
}

export interface EigenschaftenBezeichnung {
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;

    [key: string]: any;
}

export interface EigenschaftenBezeichnungenUebersetzungen {
    eigenschaften1: { [key: string]: string; };
    eigenschaften2: { [key: string]: string; };
    eigenschaften3: { [key: string]: string; };
    eigenschaften4: { [key: string]: string; };
    eigenschaften5: { [key: string]: string; };

    [key: string]: any;
}

export interface Einstellungen {
    alleSpalten: { [key: string]: { [key: string]: TabellenSpalte; }; };
    tabellenLayouts: { [key: string]: TabellenLayout; };
    sortierungen: Sortierungen;
    standardGridPageSizes: number[];
    standardGridPageSize: number;
    eigenschaftenBezeichnungen: EigenschaftenBezeichnungenUebersetzungen;
    etikettendruck: Etikettendruck;
    gueltigeUploadDateiendungen: string[];
    ergebnisDetailLayout: ErgebnisDetailLayout;
    mibiMoeglicheUrsachenNutzungsbedingungenGelesen: boolean;
    nutzungsbedingungenGelesen: boolean;
    rechte: { [key: string]: boolean; };

    [key: string]: any;
}

export interface Element {
    name?: string;
    typ?: ElementTyp;
    url?: string | null;
    kinder?: Element[];

    [key: string]: any;
}

export enum ElementTyp {
    Ordner = "Ordner",
    Datei = "Datei",
}

export interface EndgueltigeErgebnisseFilter {
    mibiBeurteilung?: (Beurteilung | null)[];
    chemieBeurteilung?: (Beurteilung | null)[];
    mibiBelastungstestBeurteilung?: (Beurteilung | null)[];
    sensorikBeurteilung?: (Beurteilung | null)[];
    erlaubteProbentyp?: Probentyp[];
    probentyp?: Probentyp[];
    probentypMehrfachauswahlErlaubt?: boolean;
    pruefplan?: string | null;
    probenNr?: number | null;
    bezeichnung?: string | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    lieferant?: string | null;
    mhd?: string | null;
    filterTyp?: FilterTyp;
    eingangsdatumFilterVerfuegbar?: boolean;
    eingangsdatumVon?: Date | null;
    eingangsdatumBis?: Date | null;
    datumProbenziehungVon?: Date | null;
    datumProbenziehungBis?: Date | null;
    ausgangsdatumFilterVerfuegbar?: boolean;
    ausgangsdatumVon?: Date | null;
    ausgangsdatumBis?: Date | null;
    erlaubteFilterTypen?: FilterTyp[];
    parameterbezeichnung?: string | null;

    [key: string]: any;
}

export enum ErgebnisDetailLayout {
    Ausfuehrlich = "Ausfuehrlich",
    Kompakt = "Kompakt",
}

export interface ErgebnisProbe {
    probenID?: number;
    probenNr?: number;
    bezeichnung?: string | null;
    ausgangsdatum?: Date | null;
    mibiAusgangsdatum?: Date | null;
    chemieAusgangsdatum?: Date | null;
    mibiBelastungstestAusgangsdatum?: Date | null;
    datumProbenziehung?: Date | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    eingangsdatum?: Date | null;
    herstellungsdatum?: Date | null;
    lieferant?: string | null;
    lieferdatum?: Date | null;
    mhd?: string | null;
    ortDerProbenziehung?: string | null;
    alternativerOrtDerProbenziehung?: string | null;
    temperatur?: string | null;
    zeitpunktProbenziehung?: Date | null;
    probenHinweisExtern?: string | null;
    mibiPruefplanCode?: string | null;
    chemiePruefplanCode?: string | null;
    mibiBelastungstestPruefplanCode?: string | null;
    mibiBeurteilung?: MibiBeurteilung | null;
    chemieBeurteilung?: ChemieBeurteilung | null;
    mibiBelastungstestBeurteilung?: MibiBelastungstestBeurteilung | null;
    sensorikGesamtBeurteilung?: SensorikGesamtBeurteilung | null;
    vorlaeufigeMibiBeurteilung?: VorlaeufigeMibiBeurteilung | null;
    vorlaeufigeMibiBelastungstestBeurteilung?: VorlaeufigeMibiBelastungstestBeurteilung | null;
    probenErgebnisAufgerufen?: boolean;
    gesamtBeurteilung?: GesamtBeurteilung | null;
    mibiIdentifizierungAbgeschlossenAm?: Date | null;
    mibiIdentifizierungErgebnis?: string | null;
    bavLimsMibiIdentifizierungsVersion?: number;
    mibiParameterAnzahl?: number;
    chemieParameterAnzahl?: number;
    sensorikParameterAnzahl?: number;
    mibiBelastungstestParameterAnzahl?: number;
    probenportalFreigabeAm?: Date | null;
    url?: string | null;
    mibiUntersuchungsbeginn?: Date | null;
    mibiBelastungstestUntersuchungsbeginn?: Date | null;

    [key: string]: any;
}

export interface ErgebnisProbeDetail {
    ansicht?: ProbenAnsicht;
    hatMikrobiologieErgebnis?: boolean;
    hatChemieErgebnis?: boolean;
    hatBelastungstestErgebnis?: boolean;
    hatSensorik?: boolean;
    mikrobiologieMoeglicheUrsachenAnzeigen?: boolean;
    hatParameter?: boolean;
    mikrobiologie?: Mikrobiologie | null;
    mikrobiologieMoeglicheUrsachen?: { [key: string]: MoeglicheUrsachenUndVorschlaege; } | null;
    chemie?: Chemie | null;
    belastungstest?: Belastungstest | null;
    sensorik?: Sensorik | null;
    kennzeichnung?: string | null;
    verkehrsfaehigkeitsBeurteilung?: string | null;
    bilder?: string[];
    dokumente?: Dokument[];
    pruefberichtDokumente?: Dokument[];
    ergebnisDetailLayout?: ErgebnisDetailLayout;
    probenID?: number | null;
    probenNr?: number | null;
    vorlageProbe?: Probe | null;
    bezeichnung: string | null;
    eingangsdatum?: Date | null;
    mibiAusgangsdatum?: Date | null;
    chemieAusgangsdatum?: Date | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    herstellungsdatum?: Date | null;
    mhd?: string | null;
    lieferant?: string | null;
    lieferdatum?: Date | null;
    datumProbenziehung?: Date | null;
    zeitpunktProbenziehung?: Date | null;
    temperatur?: string | null;
    alternativerOrtDerProbenziehung?: string | null;
    ortDerProbenziehung?: string | null;
    probenHinweisExtern?: string | null;
    myBavLimsFreigabeAm?: Date | null;
    myBavLimsFreigabeVonAPID?: number | null;
    etikettenGedrucktAm?: Date | null;
    etikettenGedrucktVon?: number | null;
    probenbegleitscheinGedrucktAm?: Date | null;
    probenbegleitscheinGedrucktVon?: number | null;
    mustervorlage?: boolean;
    mustervorlagenNr?: number | null;
    vorlageProbenID?: number | null;
    sindProbennummernReservierungenVorhanden?: boolean | null;
    ausgewaehlteReservierteProbenNr?: number | null;
    rechnungsKennzeichen?: string | null;
    navigation?: Navigation;
    mischprobe?: Mischprobe;
    testzeitpunkt?: TestzeitpunktModel;

    [key: string]: any;
}

export interface Etikettendruck {
    standardEtikettenLayout: EtikettenLayout;
    etikettenLayoutDefinitionen: { [key: string]: EtikettenLayoutDefinition; };

    [key: string]: any;
}

export interface EtikettenDruckenRequest {
    probenNrs: number[];
    layout: EtikettenLayout;

    [key: string]: any;
}

export interface EtikettendruckFilter {
    gedrucktStatus: GedrucktStatus;
    etikettendruckFilterTyp: EtikettendruckFilterTyp;

    [key: string]: any;
}

export enum EtikettendruckFilterTyp {
    Benutzerdefiniert = "Benutzerdefiniert",
    KeinFilter = "KeinFilter",
}

export interface EtikettenErneutDruckenRequest {
    vorgangsID: number;

    [key: string]: any;
}

export enum EtikettenLayout {
    Anzahl65 = "Anzahl65",
    Anzahl24 = "Anzahl24",
}

export interface EtikettenLayoutDefinition {
    etikettenLayout: EtikettenLayout;
    anzahlProBogen: number;
    maxAnzahlBoegen: number;

    [key: string]: any;
}

export interface EtikettenVordruckenRequest {
    layout: EtikettenLayout;
    anzahl: number;

    [key: string]: any;
}

export interface ExcelExportOptionenParameter {
    richtUndWarnwertExportieren?: boolean;

    [key: string]: any;
}

export enum FilterTyp {
    Benutzerdefiniert = "Benutzerdefiniert",
    LetzterMonat = "LetzterMonat",
    LetzteZweiMonate = "LetzteZweiMonate",
    KeinFilter = "KeinFilter",
}

export enum GedrucktStatus {
    Alle = "Alle",
    NichtGedruckt = "NichtGedruckt",
    Gedruckt = "Gedruckt",
}

export enum GutachtenAnsicht {
    Erfassen = "Erfassen",
    InBearbeitung = "InBearbeitung",
    Ergebnisse = "Ergebnisse",
    Rohstoffspezifikationen = "Rohstoffspezifikationen",
}

export interface GutachtenFilter {
    filterTyp?: GutachtenFilterTyp;
    gutachtenNr?: number | null;
    version?: number | null;
    bezeichnung?: string | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    freigegebenAmVon?: Date | null;
    freigegebenAmBis?: Date | null;

    [key: string]: any;
}

export enum GutachtenFilterTyp {
    Benutzerdefiniert = "Benutzerdefiniert",
    LetzteZwoelfMonate = "LetzteZwoelfMonate",
    KeinFilter = "KeinFilter",
}

export interface GutachtenSuchtreffer {
    gutachtenVersionID?: number;
    gutachtenNrUndVersionFormatiert?: string | null;
    bezeichnung?: string | null;
    ansicht?: GutachtenAnsicht;
    gutachtenNr?: number;
    version?: number;

    [key: string]: any;
}

export enum GutachtenTyp {
    Sicherheitsbericht = "Sicherheitsbericht",
}

export interface GutachtenVersion {
    gutachtenID?: number;
    gutachtenNr?: number;
    gutachtenTypID?: GutachtenTyp | null;
    bezeichnung?: string;
    rezepturNr?: string | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    gutachtenVersionID?: number;
    version?: number;
    freigegebenAm?: Date | null;
    myBavLimsFreigabeAm?: Date | null;
    sprache?: PruefberichtSprache;
    gutachtenNrFormatiert?: string | null;
    gutachtenNrUndVersionFormatiert?: string | null;
    ergebnisAufgerufen?: boolean;
    navigation?: Navigation;
    dokumente?: Dokument[];
    id?: number;

    [key: string]: any;
}

export interface GutachtenVersionEdit {
    gutachtenID?: number | null;
    gutachtenVersionID?: number | null;
    gutachtenNr?: number | null;
    version?: number | null;
    gutachtenTypID: GutachtenTypID | null;
    bezeichnung: string | null;
    rezepturNr?: string | null;
    sprache: PruefberichtSprache | null;
    myBavLimsFreigabeAm?: Date | null;
    myBavLimsFreigabeVonAPID?: number | null;
    gutachtenNrFormatiert?: string | null;
    gutachtenNrUndVersionFormatiert?: string | null;
    navigation?: Navigation;

    [key: string]: any;
}

export interface ImLaborFilter {
    erlaubteProbentyp?: Probentyp[];
    probentyp?: Probentyp[];
    probentypMehrfachauswahlErlaubt?: boolean;
    pruefplan?: string | null;
    probenNr?: number | null;
    bezeichnung?: string | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    lieferant?: string | null;
    mhd?: string | null;
    filterTyp?: FilterTyp;
    eingangsdatumFilterVerfuegbar?: boolean;
    eingangsdatumVon?: Date | null;
    eingangsdatumBis?: Date | null;
    datumProbenziehungVon?: Date | null;
    datumProbenziehungBis?: Date | null;
    ausgangsdatumFilterVerfuegbar?: boolean;
    ausgangsdatumVon?: Date | null;
    ausgangsdatumBis?: Date | null;
    erlaubteFilterTypen?: FilterTyp[];
    parameterbezeichnung?: string | null;

    [key: string]: any;
}

export interface ImportErfolgreichErgebnis {
    importierteProbenNrs: number[];
    dateiname: string;
    freigabeRechtVorhanden: boolean;

    [key: string]: any;
}

export enum InternetFreigabeRecht {
    Erfassen = "Erfassen",
    MusterprobeErfassen = "MusterprobeErfassen",
    ProbenFreigabe = "ProbenFreigabe",
    TextvorlagenErfassen = "TextvorlagenErfassen",
    Kundenbereich = "Kundenbereich",
    MischprobeFestlegen = "MischprobeFestlegen",
    Labor = "Labor",
    LaborBelastungstest = "LaborBelastungstest",
    VErgebnisse = "VErgebnisse",
    VErgebnisseBelastungstest = "VErgebnisseBelastungstest",
    Ergebnisse = "Ergebnisse",
    ErgebnisseBelastungstest = "ErgebnisseBelastungstest",
    EMailBenachrichtigungVErgebnis = "EMailBenachrichtigungVErgebnis",
    EMailBenachrichtigungErgebnis = "EMailBenachrichtigungErgebnis",
    EMailBenachrichtigungVErgebnisBelastungstest = "EMailBenachrichtigungVErgebnisBelastungstest",
    EMailBenachrichtigungErgebnisBelastungstest = "EMailBenachrichtigungErgebnisBelastungstest",
    Checklisten = "Checklisten",
    EmailBenachrichtigungChecklistenFreigabe = "EmailBenachrichtigungChecklistenFreigabe",
    GutachtenVersionenErgebnisse = "GutachtenVersionenErgebnisse",
    EmailBenachrichtigungGutachtenVersionenFreigabe = "EmailBenachrichtigungGutachtenVersionenFreigabe",
    AdminBereich = "AdminBereich",
    WebApiSchreibzugriff = "WebApiSchreibzugriff",
    AussendienstAppZugriff = "AussendienstAppZugriff",
    AussendienstAppProbenErfassen = "AussendienstAppProbenErfassen",
    AussendienstAppChecklistenErfassen = "AussendienstAppChecklistenErfassen",
    AussendienstAppLeistungenErfassen = "AussendienstAppLeistungenErfassen",
}

export interface KennwortAendernRequest {
    aktuellesKennwort: string;
    neuesKennwort: string;
    neuesKennwortBestaetigung: string;

    [key: string]: any;
}

export interface KriterienTabelle {
    bezeichnung?: string | null;
    tabelle?: BelastungstestTabelle | null;
    fussnote?: string | null;

    [key: string]: any;
}

export interface Kunde {
    kundenID?: number;
    kundennummer: string;
    mutterKundenID?: number | null;
    abteilungsID?: number | null;
    name?: string | null;
    adresse?: string | null;
    plz?: string | null;
    strasse?: string | null;
    ort?: string | null;

    [key: string]: any;
}

export interface KundenRohstoffspezifikation {
    kundenRohstoffspezifikationID?: number;
    bezeichnung?: string;
    artikelNr?: string | null;
    lieferant?: string | null;
    lohnhersteller?: string | null;
    rohstoffart?: Rohstoffart;

    [key: string]: any;
}

export interface KundeUndUnterkunden {
    kunde: Kunde;
    unterkunden: Kunde[];

    [key: string]: any;
}

export interface LayoutAktualisierenRequest {
    ansicht?: Ansicht;
    spalten?: string[];

    [key: string]: any;
}

export interface LogItem {
    zeile: number | null;
    spalte: string | null;
    meldung: string;

    [key: string]: any;
}

export interface MibiParameter {
    bezeichnung?: string | null;
    ergebniswert?: string | null;
    richtwert?: string | null;
    warnwert?: string | null;
    messunsicherheit?: string | null;
    mibiIdentifizierungsErgebnisHtml?: string | null;

    [key: string]: any;
}

export interface Mikrobiologie {
    beurteilung?: Beurteilung | null;
    pruefplan?: string | null;
    mibiUntersuchungsbeginn?: Date | null;
    identifizierung?: string | null;
    bemerkung?: string | null;
    pruefberichtSprache?: string | null;
    mibiErgebnisMitMessunsicherheit?: boolean;
    parameter?: MibiParameter[];
    parameterMitIdentifizierungsErgebnisse?: MibiParameter[];
    grenzwertBezeichnung?: { [key: string]: string; };

    [key: string]: any;
}

export interface Mischprobe {
    mibiMischprobenTypID: MibiMischprobenTypID | null;
    mibiMischprobenVariante?: MibiMischprobenVariante | null;
    mibiMischprobeMusterAnzahl?: number | null;
    mischprobenButtonText?: string | null;

    [key: string]: any;
}

export enum MischprobenTyp {
    Standardprobe = "Standardprobe",
    Mischprobe = "Mischprobe",
}

export enum MischprobenVariante {
    AnfangMitteEnde = "AnfangMitteEnde",
    AnfangEnde = "AnfangEnde",
    Benutzerdefiniert = "Benutzerdefiniert",
}

export interface MischprobeResponse {
    model: Mischprobe;
    warnungen: string[];

    [key: string]: any;
}

export interface MoeglicheUrsachenUndVorschlaege {
    parameterOhneMoeglicheUrsachenUndVorschlaegeVorgaben: string[];
    allgemeineHinweise: string[];
    ursacheUndVorschlaege: MoeglicheUrsacheUndVorschlaege[];

    [key: string]: any;
}

export interface MoeglicheUrsacheUndVorschlaege {
    ursacheTitel: string;
    ursacheBeschreibung: string;
    vorschlaege: Vorschlag[];

    [key: string]: any;
}

export interface MustervorlagenFilter {
    mustervorlagenNr?: number | null;
    bezeichnung?: string | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    lieferant?: string | null;

    [key: string]: any;
}

export interface Navigation {
    first?: number | null;
    previous?: number | null;
    next?: number | null;
    last?: number | null;

    [key: string]: any;
}

export interface News {
    erstelltAm?: Date;
    titel?: string;
    inhalt?: string;
    url?: string;

    [key: string]: any;
}

export interface PaginatedResultOfCheckliste {
    total: number;
    items: Checkliste[];

    [key: string]: any;
}

export interface PaginatedResultOfGutachtenVersion {
    total: number;
    items: GutachtenVersion[];

    [key: string]: any;
}

export interface PaginatedResultOfKundenRohstoffspezifikation {
    total: number;
    items: KundenRohstoffspezifikation[];

    [key: string]: any;
}

export interface PaginatedResultOfProbe {
    total: number;
    items: Probe[];

    [key: string]: any;
}

export interface PaginatedResultOfProbennummernReservierungsVorgang {
    total: number;
    items: ProbennummernReservierungsVorgang[];

    [key: string]: any;
}

export interface PaginatedResultOfPruefplan {
    total: number;
    items: Pruefplan[];

    [key: string]: any;
}

export interface PaginatedResultOfQualitaetskontrollZertifikat {
    total: number;
    items: QualitaetskontrollZertifikat[];

    [key: string]: any;
}

export interface PaginatedResultOfTextvorlage {
    total: number;
    items: Textvorlage[];

    [key: string]: any;
}

export interface PaginatedResultWithFilterOfErgebnisProbeAndAngemeldeteFilter {
    totalUngefiltert: number;
    filterVorhanden: boolean;
    filter: AngemeldeteFilter | null;
    total: number;
    items: ErgebnisProbe[];

    [key: string]: any;
}

export interface PaginatedResultWithFilterOfErgebnisProbeAndEndgueltigeErgebnisseFilter {
    totalUngefiltert: number;
    filterVorhanden: boolean;
    filter: EndgueltigeErgebnisseFilter | null;
    total: number;
    items: ErgebnisProbe[];

    [key: string]: any;
}

export interface PaginatedResultWithFilterOfErgebnisProbeAndImLaborFilter {
    totalUngefiltert: number;
    filterVorhanden: boolean;
    filter: ImLaborFilter | null;
    total: number;
    items: ErgebnisProbe[];

    [key: string]: any;
}

export interface PaginatedResultWithFilterOfErgebnisProbeAndVorlaufigeErgebnisseFilter {
    totalUngefiltert: number;
    filterVorhanden: boolean;
    filter: VorlaufigeErgebnisseFilter | null;
    total: number;
    items: ErgebnisProbe[];

    [key: string]: any;
}

export interface PaginatedResultWithFilterOfGutachtenVersionAndGutachtenFilter {
    totalUngefiltert: number;
    filterVorhanden: boolean;
    filter: GutachtenFilter | null;
    total: number;
    items: GutachtenVersion[];

    [key: string]: any;
}

export interface PaginatedResultWithFilterOfProbeAndEtikettendruckFilter {
    totalUngefiltert: number;
    filterVorhanden: boolean;
    filter: EtikettendruckFilter | null;
    total: number;
    items: Probe[];

    [key: string]: any;
}

export interface PaginatedResultWithFilterOfProbeAndMustervorlagenFilter {
    totalUngefiltert: number;
    filterVorhanden: boolean;
    filter: MustervorlagenFilter | null;
    total: number;
    items: Probe[];

    [key: string]: any;
}

export interface PaginatedResultWithFilterOfProbeAndProbenbegleitscheinDruckFilter {
    totalUngefiltert: number;
    filterVorhanden: boolean;
    filter: ProbenbegleitscheinDruckFilter | null;
    total: number;
    items: Probe[];

    [key: string]: any;
}

export interface Probe {
    probenID?: number | null;
    probenNr?: number | null;
    vorlageProbe?: Probe | null;
    bezeichnung: string | null;
    eingangsdatum?: Date | null;
    mibiAusgangsdatum?: Date | null;
    chemieAusgangsdatum?: Date | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    herstellungsdatum?: Date | null;
    mhd?: string | null;
    lieferant?: string | null;
    lieferdatum?: Date | null;
    datumProbenziehung?: Date | null;
    zeitpunktProbenziehung?: Date | null;
    temperatur?: string | null;
    alternativerOrtDerProbenziehung?: string | null;
    ortDerProbenziehung?: string | null;
    probenHinweisExtern?: string | null;
    myBavLimsFreigabeAm?: Date | null;
    myBavLimsFreigabeVonAPID?: number | null;
    etikettenGedrucktAm?: Date | null;
    etikettenGedrucktVon?: number | null;
    probenbegleitscheinGedrucktAm?: Date | null;
    probenbegleitscheinGedrucktVon?: number | null;
    mustervorlage?: boolean;
    mustervorlagenNr?: number | null;
    vorlageProbenID?: number | null;
    sindProbennummernReservierungenVorhanden?: boolean | null;
    ausgewaehlteReservierteProbenNr?: number | null;
    rechnungsKennzeichen?: string | null;
    navigation?: Navigation;
    mischprobe?: Mischprobe;
    testzeitpunkt?: TestzeitpunktModel;

    [key: string]: any;
}

export enum ProbenAnsicht {
    Angemeldete = "Angemeldete",
    ImLabor = "ImLabor",
    VorlaufigeErgebnisse = "VorlaufigeErgebnisse",
    EndgueltigeErgebnisse = "EndgueltigeErgebnisse",
    Mustervorlagen = "Mustervorlagen",
    ProbenErfassen = "ProbenErfassen",
    Etikettendruck = "Etikettendruck",
    ProbenbegleitscheinDruck = "ProbenbegleitscheinDruck",
}

export interface ProbenbegleitscheinDruckenRequest {
    probenNrs: number[];
    hinweis?: string | null;

    [key: string]: any;
}

export interface ProbenbegleitscheinDruckFilter {
    gedrucktStatus: GedrucktStatus;
    probenbegleitscheinDruckFilterTyp: ProbenbegleitscheinDruckFilterTyp;

    [key: string]: any;
}

export enum ProbenbegleitscheinDruckFilterTyp {
    Benutzerdefiniert = "Benutzerdefiniert",
    KeinFilter = "KeinFilter",
}

export enum ProbenergebnisTyp {
    OhneParameter = "OhneParameter",
    MitParameter = "MitParameter",
}

export enum ProbenExportTyp {
    MitGesamtbewertung = "MitGesamtbewertung",
    MitMibiEinzelbewertung = "MitMibiEinzelbewertung",
    MitChemieEinzelbewertung = "MitChemieEinzelbewertung",
    MitMibiEinzelbewertungPivot = "MitMibiEinzelbewertungPivot",
}

export interface ProbenFreigebenRequest {
    probenNrs?: number[];

    [key: string]: any;
}

export interface ProbenImportVorschauErgebnis {
    spalten: TabellenSpalte[];
    zeilen: Zeile[];
    protokoll: LogItem[];
    importMoeglich: boolean;

    [key: string]: any;
}

export interface ProbennummernReservierungsVorgang {
    probennummernReservierungsVorgangID: number;
    reserviertAm: Date;
    reserviertVon: string;
    layout: EtikettenLayout;
    anzahl: number;

    [key: string]: any;
}

export enum Probentyp {
    Mibi = "Mibi",
    Chemie = "Chemie",
    MibiBelastungstest = "MibiBelastungstest",
}

export interface ProbeResponse {
    probe: Probe;
    warnungen: string[];

    [key: string]: any;
}

export interface ProbeSuchtreffer {
    probenNr?: number;
    bezeichnung?: string | null;
    ansicht?: ProbenAnsicht;

    [key: string]: any;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export enum PruefberichtSprache {
    De = "de",
    En = "en",
    Fr = "fr",
}

export interface Pruefplan {
    pruefplanID?: number;
    pruefplanCode: string;
    bezeichnung: string;
    quelle?: string | null;
    mibi?: boolean;

    [key: string]: any;
}

export interface PruefplanPosition {
    positionID: number;
    pruefplanID: number;
    bezeichnung: string;
    einheit?: string | null;
    richtwert?: string | null;
    warnwert?: string | null;
    nachweisgrenze?: string | null;
    methode?: string | null;

    [key: string]: any;
}

export interface QualitaetskontrollZertifikat {
    jahr: number;

    [key: string]: any;
}

export enum Rohstoffart {
    Rohstoff = "Rohstoff",
    Packmittel = "Packmittel",
}

export interface Sensorik {
    gesamtBeurteilung?: Beurteilung | null;
    beurteilungKurz?: string | null;
    parameter?: SensorikParameter[];
    bewertungsPunkte?: boolean;
    pruefberichtSprache?: PruefberichtSprache;
    sensorikBeurteilungStichwortBezeichnung: string;

    [key: string]: any;
}

export interface SensorikParameter {
    beurteilung: string | null;
    stichwort: string;
    bewertungsPunkte?: number | null;

    [key: string]: any;
}

export interface Sortierung {
    feldName: string;
    richtung: number;

    [key: string]: any;
}

export interface SortierungDefinition {
    sortString: string | null;
    sortierungen: Sortierung[];
    beschreibung: { [key: string]: string; };

    [key: string]: any;
}

export interface SortierungDefinitionen {
    aktuelleSortierung: SortierungDefinition;
    standardSortierung: SortierungDefinition;

    [key: string]: any;
}

export interface Sortierungen {
    proben: { [key: string]: SortierungDefinitionen; };
    begehungsberichte: SortierungDefinitionen;
    gutachten: { [key: string]: SortierungDefinitionen; };

    [key: string]: any;
}

export interface SpaTexte {
    sprache?: string;
    texte?: { [key: string]: string; };

    [key: string]: any;
}

export interface Statistik {
    erlaubteProbentyp?: Probentyp[];
    probentyp?: Probentyp[];
    probentypMehrfachauswahlErlaubt?: boolean;
    pruefplan?: string | null;
    probenNr?: number | null;
    bezeichnung?: string | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    lieferant?: string | null;
    mhd?: string | null;
    filterTyp?: FilterTyp;
    eingangsdatumFilterVerfuegbar?: boolean;
    eingangsdatumVon?: Date | null;
    eingangsdatumBis?: Date | null;
    datumProbenziehungVon?: Date | null;
    datumProbenziehungBis?: Date | null;
    ausgangsdatumFilterVerfuegbar?: boolean;
    ausgangsdatumVon?: Date | null;
    ausgangsdatumBis?: Date | null;
    erlaubteFilterTypen?: FilterTyp[];
    parameterbezeichnung?: string | null;

    [key: string]: any;
}

export interface StatistikKuchendiagrammRequest {
    filter: Statistik;

    [key: string]: any;
}

export interface StatistikPieItem {
    beurteilung: Beurteilung | null;
    name: string;
    anzahlProzent: number;
    anzahl: number;
    color: Color;

    [key: string]: any;
}

export interface StatistikProbenlisteRequest {
    filter: Statistik;
    probenergebnisTyp: ProbenergebnisTyp;

    [key: string]: any;
}

export interface Suchtreffer {
    proben?: ProbeSuchtreffer[];
    gutachten?: GutachtenSuchtreffer[];
    probenTotal?: number;
    gutachtenTotal?: number;
    total?: number;

    [key: string]: any;
}

export interface TabellenLayout {
    ansicht: Ansicht;
    spalten: TabellenSpalte[];

    [key: string]: any;
}

export interface TabellenSpalte {
    name: string;
    uebersetzungen?: { [key: string]: string; };
    datumFormat?: string | null;
    breite?: number;
    istEigenschaft?: boolean;
    eigenschaftIndex?: number | null;
    istStandardSpalte?: boolean;
    istPflichtspalte?: boolean;

    [key: string]: any;
}

export interface Telefonnummer {
    formatiert: string;
    unformatiert: string;

    [key: string]: any;
}

export enum Testzeitpunkt {
    Standard = "Standard",
    Lager = "Lager",
    MHD = "MHD",
    Einlagerung = "Einlagerung",
}

export interface TestzeitpunktModel {
    testzeitpunkt?: Testzeitpunkt;
    untersuchungsbeginn?: Date | null;
    testzeitpunktTexte?: { [key: string]: string; };

    [key: string]: any;
}

export interface Textvorlage {
    textvorlageID?: number | null;
    kundenID?: number;
    probenID?: number | null;
    quelle?: TextvorlagenQuelle;
    feldname: string;
    text: string;
    bearbeitenErlaubt?: boolean;

    [key: string]: any;
}

export enum TextvorlagenQuelle {
    Allgemein = "Allgemein",
    ProbenVorlage = "ProbenVorlage",
}

export interface UpdateErgebnisDetailLayoutRequest {
    layout: ErgebnisDetailLayout;

    [key: string]: any;
}

export interface ValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export interface VorlaufigeErgebnisseFilter {
    mibiBeurteilung?: (Beurteilung | null)[];
    mibiBelastungstestBeurteilung?: (Beurteilung | null)[];
    sensorikBeurteilung?: (Beurteilung | null)[];
    erlaubteProbentyp?: Probentyp[];
    probentyp?: Probentyp[];
    probentypMehrfachauswahlErlaubt?: boolean;
    pruefplan?: string | null;
    probenNr?: number | null;
    bezeichnung?: string | null;
    eigenschaften1?: string | null;
    eigenschaften2?: string | null;
    eigenschaften3?: string | null;
    eigenschaften4?: string | null;
    eigenschaften5?: string | null;
    lieferant?: string | null;
    mhd?: string | null;
    filterTyp?: FilterTyp;
    eingangsdatumFilterVerfuegbar?: boolean;
    eingangsdatumVon?: Date | null;
    eingangsdatumBis?: Date | null;
    datumProbenziehungVon?: Date | null;
    datumProbenziehungBis?: Date | null;
    ausgangsdatumFilterVerfuegbar?: boolean;
    ausgangsdatumVon?: Date | null;
    ausgangsdatumBis?: Date | null;
    erlaubteFilterTypen?: FilterTyp[];
    parameterbezeichnung?: string | null;

    [key: string]: any;
}

export interface Vorschlag {
    text: string;
    relevantFuerAlleParameter: boolean;
    relevantFuerParameter: string[];

    [key: string]: any;
}

export interface Zeile {
    zellen?: Zelle[];
    cssKlasse?: string | null;
    istTabellenKopf?: boolean;

    [key: string]: any;
}

export interface Zelle {
    span?: number;
    cssClass?: string | null;
    hatPfeil?: boolean;
    wert?: string | null;

    [key: string]: any;
}

export interface ZertifikatDownloadRequest {
    jahr: number;

    [key: string]: any;
}

export interface Body {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: { [key: string]: string[]; };
    Length?: number;
    Name?: string;
    FileName?: string;

    [key: string]: any;
}

export interface Body2 {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: { [key: string]: string[]; };
    Length?: number;
    Name?: string;
    FileName?: string;

    [key: string]: any;
}

export interface Body3 {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: { [key: string]: string[]; };
    Length?: number;
    Name?: string;
    FileName?: string;

    [key: string]: any;
}

export interface Body4 {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: { [key: string]: string[]; };
    Length?: number;
    Name?: string;
    FileName?: string;

    [key: string]: any;
}

export interface Body5 {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: { [key: string]: string[]; };
    Length?: number;
    Name?: string;
    FileName?: string;

    [key: string]: any;
}

export interface Body6 {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: { [key: string]: string[]; };
    Length?: number;
    Name?: string;
    FileName?: string;

    [key: string]: any;
}

export interface Body7 {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: { [key: string]: string[]; };
    Length?: number;
    Name?: string;
    FileName?: string;

    [key: string]: any;
}

export interface Body8 {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: { [key: string]: string[]; };
    Length?: number;
    Name?: string;
    FileName?: string;

    [key: string]: any;
}

export interface MibiBeurteilung {

    [key: string]: any;
}

export interface ChemieBeurteilung {

    [key: string]: any;
}

export interface MibiBelastungstestBeurteilung {

    [key: string]: any;
}

export interface SensorikGesamtBeurteilung {

    [key: string]: any;
}

export interface VorlaeufigeMibiBeurteilung {

    [key: string]: any;
}

export interface VorlaeufigeMibiBelastungstestBeurteilung {

    [key: string]: any;
}

export interface GesamtBeurteilung {

    [key: string]: any;
}

export interface GutachtenTypID {

    [key: string]: any;
}

export interface MibiMischprobenTypID {

    [key: string]: any;
}

export interface MibiMischprobenVariante {

    [key: string]: any;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}